import React from 'react';
import { ContainerStyled } from './Container.styles';
/**
 * @param outlined: Adds a border
 * @param shadow: Adds a drop shadow
 * @param square: Makes the border square, curved by default
 *
 * @returns A container to house other components
 */
const Container = ({ children, outlined, shadow, rounded, ...props }) => {
    return (React.createElement(ContainerStyled, { outlined: outlined, shadow: shadow, rounded: rounded, ...props }, children));
};
export default Container;
//# sourceMappingURL=Container.js.map